// Classes.
import {AthleteGeneralInfoItem} from '../types/athlete-general-info.item';
import {RecordBaseItem} from '../types/record-base.item';

// Services.
import {FactoryService} from '../../wa-services/factory-service';


export class RecordItem extends RecordBaseItem {

  public athlete: AthleteGeneralInfoItem;

  constructor(rawRecordItem: any,
    protected factory: FactoryService) {
    super(rawRecordItem, factory);

    // Obtain individual athlete info.
    let archer = rawRecordItem.Archers;
      
    // Archer object has no NOC, add it from the record object.
    archer.NOC = rawRecordItem.NOC;

    // Build AthleteGeneralInfoItem instance.
    this.athlete = this.factory.newAthleteGeneralInfoItem(archer);
  }

  getLabel(): string {
    return this.athlete.completeNameHtml;
  }

  getPicture(): string {
    return this.athlete.picUrl;
  }

  getSubjectId(): any {
    return this.athlete.id;
  }
}